define('modules/auth/signup/views/signup.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    '//www.google.com/recaptcha/api.js?render=6LeKEq0UAAAAAEfDq9CI0xiXXVH077iEiQTaUnwt',
    'modules/auth/models/signup.contact.model',
    'modules/base/models/default.token.model',
    'modules/base/views/model.view',
    'text!modules/auth/signup/template/signup.template.html',
    'text!modules/auth/signup/template/signup.success.template.html',
    'moment'
], function(
    Prospector,
    $,_,Backbone,
    grecaptcha,
    SignUpModel,
    TokenModel,
    ModelView,
    Template,
    SuccessTemplate,
    moment
){
    var SignUpView = ModelView.extend({
        template:_.template(Template),
        className: 'signUpView unAuthView',
        inputWait: 850,
        events:function(){
            return {
                'keyup #userFirstName'  : 'checkFirstName',
                'keyup #userLastName'   : 'checkLastName',
                'keyup #userEmail'      : 'checkEmail',
                'keyup #title'          : 'checkTitle',
                'keyup #company'        : 'checkCompany',
                'keyup #phone'          : 'checkPhone',
                'click .signUp'         : 'procSignUp'
            };
        },
        successTemplate: _.template(SuccessTemplate),
        buildModel: function () {
            this.model = new TokenModel();
        },
        passValidation:function(selector, msg){
            this.$(selector).removeClass('has-error').addClass('has-success');
            this.$(selector + ' .help-block').html(msg);
        },
        failValidation:function(selector, msg){
            this.$(selector).removeClass('has-success').addClass('has-error');
            this.$(selector + ' .help-block').html(msg);
        },
        /***** First Name Field *****/
        checkFirstName:function(){
            window.setTimeout($.proxy(function(){
                this.procCheckFirstName();
            }, this), this.inputWait);
        },
        procCheckFirstName:function(){
            var isValid = false;
            var val = this.$('#userFirstName').val();
            if(val != undefined && val.length > 1){
                this.passValidation('.firstNameChecker', 'First name looks good.');
                isValid = true;
            } else {
                this.failValidation('.firstNameChecker', 'First name must have more than one character.');
            }
            return isValid;
        },



        /***** Last Name Field *****/
        checkLastName:function(){
            window.setTimeout($.proxy(function(){
                this.procCheckLastName();
            }, this), this.inputWait);
        },
        procCheckLastName:function(){
            var isValid = false;
            var val = this.$('#userLastName').val();
            if(val != undefined && val.length > 1){
                this.passValidation('.lastNameChecker', 'Last name looks great.');
                isValid = true;
            } else {
                this.failValidation('.lastNameChecker', 'Last name must have more than one character.');
            }
            return isValid;
        },

        /***** Email Field *****/
        checkEmail:function(){
            window.setTimeout($.proxy(function(){
                this.procCheckEmail();
            }, this), this.inputWait);
        },
        procCheckEmail:function(){
            var isValid = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var val = this.$('#userEmail').val();
            if(re.test(val)){
                this.passValidation('.userEmailChecker', 'We will send your verification e-mail here.');
                isValid = true;
            } else {
                this.failValidation('.userEmailChecker', 'Enter a valid e-mail.');
            }
            return isValid;

        },

        /***** Title Field *****/
        checkTitle:function(){
            window.setTimeout($.proxy(function(){
                this.procCheckTitle();
            }, this), this.inputWait);
        },
        procCheckTitle:function(){
            var isValid = false;
            var val = this.$('#title').val();
            if(val.trim().length > 2){
                this.passValidation('.titleChecker', 'Looks good.');
                isValid = true;
            } else {
                this.failValidation('.titleChecker', 'Title cannot be blank.');
            }
            return isValid;

        },

        /***** Company Field *****/
        checkCompany:function(){
            window.setTimeout($.proxy(function(){
                this.procCheckCompany();
            }, this), this.inputWait);
        },
        procCheckCompany:function(){
            var isValid = false;
            var val = this.$('#company').val();
            if(val.trim().length > 2){
                this.passValidation('.companyChecker', 'Company name is good.');
                isValid = true;
            } else {
                this.failValidation('.companyChecker', 'Company name cannot be less than 5 characters.');
            }
            return isValid;

        },



        /***** Phone Field *****/
        checkPhone:function(){
            window.setTimeout($.proxy(function(){
                this.procCheckPhone();
            }, this), this.inputWait);
        },
        procCheckPhone:function(){
            var val = this.$('#phone').val();
            var isValid = val.match(/\d/g) != null ? val.match(/\d/g).length > 9 : 0;

            if(isValid){
                this.passValidation('.phoneChecker', 'Phone number is good.');
                isValid = true;
            } else {
                this.failValidation('.phoneChecker', 'Phone number has to have at least 10 digits.');
            }

            return isValid;
        },


        buildTemp:function(){
            $(this.el).html(this.template());
            $('head').append('<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.6.1/css/font-awesome.min.css" type="text/css" />');
            this.loadScript(
                'https://www.google.com/recaptcha/api.js?render=6LeKEq0UAAAAAEfDq9CI0xiXXVH077iEiQTaUnwt',
                $.proxy(this.renderReCaptcha, this)
            );
        },
        renderReCaptcha:function(){
            if(window.grecaptcha  != undefined){
                //do nothing
            } else {
                window.setTimeout($.proxy(this.renderReCaptcha, this), 500);
            }
        },
        procSignUp:function(){
            var that = this;
            window.grecaptcha.ready(function() {
                window.grecaptcha.execute('6LeKEq0UAAAAAEfDq9CI0xiXXVH077iEiQTaUnwt', {action: 'scheduledemo'}).then(function(token) {
                    var validateArr = [
                        that.procCheckFirstName(),
                        that.procCheckLastName(),
                        that.procCheckEmail(),
                        that.procCheckCompany(),
                        that.procCheckTitle(),
                        that.procCheckPhone()
                    ];
                    var isAnyFalse = _.any(validateArr, function(val){
                        return val == false;
                    });
                    if (!isAnyFalse){
                        that.signup = new SignUpModel();
                        that.signup.set({
                            "firstName": that.$('#userFirstName').val(),
                            "lastName": that.$('#userLastName').val(),
                            "company": that.$('#company').val(),
                            "title": that.$('#title').val(),
                            "email": that.$('#userEmail').val(),
                            "phone": that.$('#phone').val(),
                            "gReCaptcha": token,
                            "referrerURL": window.location.href,
                            "promoCode": "",
                            "interest": that.$("#interests").val()
                        });
                        that.signup.once('sync', that.procCompleteSignUp, that);
                        that.signup.save();
                        return true;
                    } else{
                        return false;
                    }
                });
            });
        },
        procCompleteSignUp:function(){
            if(this.signup.has('error')){
                if(this.signup.get('error').status == -118) {
                    this.errOut("You didn't pass the robot check.");
                } else {
                    this.errOut(this.signup.get('error').message);
                }
                // window.grecaptcha.reset();
            } else {
                if(typeof fbq !== "undefined"){
                    fbq(['track', 'CompleteRegistration']);
                }
                this.$('.mainSignup').empty().html(this.successTemplate());
            }
        },
        procResponse:function(){
            this.renderReCaptcha();
        },
        // renderReCaptcha:function(){
        //     var scale = 1;
        //     if(window.grecaptcha  != undefined){
        //         //do nothing
        //     } else {
        //         window.setTimeout($.proxy(this.renderReCaptcha, this), 500);
        //     }
        // },
        errOut:function(msg){
            this.failValidation('.mainError', msg);
        }
    });
    return SignUpView;
});



